module.exports = __webpack_public_path__ + "static/media/british-indian-ocean-territory.14826402.svg";